import { del, get, post, put, upload } from '@api/request';

export async function fetchPropertyAgents(
  { appraisalService },
  authenticationToken,
  { pId },
) {
  const url = `${appraisalService}/appraisal/property/${pId}/agents`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export const fetchPropertyAccountNameListing = async (
  { appraisalService },
  authenticationToken,
  { pId },
) => {
  const url = `${appraisalService}/appraisal/property/${pId}/currentowners`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export async function fetchPropertyOwnerAgent(
  { appraisalService },
  authenticationToken,
  { propertyAgentID },
) {
  const url = `${appraisalService}/appraisal/propertyowneragent/${propertyAgentID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updatePropertyOwnerAgent(
  { appraisalService },
  authenticationToken,
  { propertyAgentID, data },
) {
  const url = `${appraisalService}/appraisal/propertyowneragent/${propertyAgentID}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export const insertPropertyOwnerAgent = async (
  { appraisalService },
  authenticationToken,
  { pID, ownerID, payload },
) => {
  const url = `${appraisalService}/appraisal/propertyowner/${pID}/${ownerID}/agents`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export async function deletePropertyOwnerAgent(
  { appraisalService },
  authenticationToken,
  { propertyAgentID },
) {
  const url = `${appraisalService}/appraisal/propertyowneragent/${propertyAgentID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export const insertPropertyOwnerAgentFile = async (
  { appraisalService },
  authenticationToken,
  { propertyAgentID, payload },
) => {
  const url = `${appraisalService}/appraisal/propertyowneragent/${propertyAgentID}/files`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
};

export const fetchPropertyOwnerAgentFiles = async (
  { appraisalService },
  authenticationToken,
  { propertyAgentID },
) => {
  const url = `${appraisalService}/appraisal/propertyowneragent/${propertyAgentID}/files`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const deletePropertyOwnerAgentFile = async (
  { appraisalService },
  authenticationToken,
  { propertyAgentID, s3ID },
) => {
  const url = `${appraisalService}/appraisal/propertyowneragent/${propertyAgentID}/file/${s3ID}`;
  const { body } = await put(authenticationToken, url);
  return body;
};

export const downloadPropertyOwnerAgentFile = async (
  { appraisalService },
  authenticationToken,
  { propertyAgentID, s3ID },
) => {
  const url = `${appraisalService}/appraisal/propertyowneragent/${propertyAgentID}/file/${s3ID}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then(response => response.blob())
    .then(blobby => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3ID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export const updatePropertyOwnerAgentFile = async (
  { appraisalService },
  authenticationToken,
  { propertyAgentID, payload },
) => {
  const url = `${appraisalService}/appraisal/propertyowneragent/${propertyAgentID}/files`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};